import { render } from "./AlContact.vue?vue&type=template&id=7d9bc5a2&scoped=true"
import script from "./AlContact.vue?vue&type=script&lang=js"
export * from "./AlContact.vue?vue&type=script&lang=js"

import "./AlContact.vue?vue&type=style&index=0&id=7d9bc5a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9bc5a2"]])

export default __exports__